import { connect } from 'react-redux'
import AppVersionDisplay from '../components/AppVersionDisplay'

const mapStateToProps = state => ({
    appVersion: state.getIn(['device', 'appVersion']),
})

export default connect(mapStateToProps)(AppVersionDisplay)
